// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2lGVV","title":"Header_title__1TAPB","side":"Header_side__2K9B8"};